import React, { useState } from "react";
import { WrapperSeamless, UsersActionCard } from "layout-components";
import Table from "components/tables/table";
import { useTranslation } from "localization/translation";
import { Button } from "@material-ui/core";
import * as Api from "service";
import { BranchDetailsButtons } from "components/user-details-wrapper/BranchDetailsButtons";
import { AcceptUserModal } from "components/modals/acceptModal";
import {
  ACTIVE_STATUS_VALUE,
  INACTIVE_STATUS_VALUE,
} from "Constants";

export const UserBranches = ({
  branchList,
  setBranchActionType,
  setIsOpenBranchAction,
  setBranchId,
  setIsBranchActive,
  setIsActionActive,
  handleDateChange,
  plans,
  currencies,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenEditModal, setIsOpenEditModal] = useState(false);
  const [openId, setOpenId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [planData, setPlanData] = useState({});


  const translation = useTranslation();

  const actionHandler = (status, id) => {
    setBranchActionType(
      !!status ? translation.deactivate : translation.activate
    );
    setIsActionActive(!!status);
    setIsOpenBranchAction(true);
    setBranchId(id);
    setIsBranchActive(!!status ? INACTIVE_STATUS_VALUE : ACTIVE_STATUS_VALUE);
  };

  const closeEditModal = () => {
    setOpenId(null);
    setIsOpenEditModal(false);
  };

  const editPlanHandler = (branchId) => {
    const branch = branchList?.find(item => item.id === branchId)
    if(branch.subscription) {
      const subscription = branch.subscription;
      const data = {
        plan_id: subscription.plan_id,
        plan_type: subscription.billing_period,
        price: subscription.price_paid,
        currency: subscription.currency_id,
        trial_period_days: subscription.trial_period_days,
        unlimited_items: subscription?.unlimited_items,
        max_inventory_items: subscription?.max_inventory_items,
        max_inventory_items_ml: subscription?.max_inventory_items_ml,
        max_inventory_items_kg_pc: subscription?.max_inventory_items_kg_pc,
        auto_subscription_start: subscription?.auto_subscription_start,
        auto_renew: subscription?.auto_renew,
      };
      setPlanData(data);
    } else {
      let planId = plans?.[0]?.id
      const data = getPlanData(planId);
      setPlanData(data);
    }
    
    setOpenId(branchId);
    setIsOpenEditModal(true);
    setIsOpen(false);
  }

  const handleSaveAction = (e) => {
    e.preventDefault();
    setLoading(true)
    
    Api.main
      .updateUserBranchSubscription({
        id: openId,
        data: planData,
      })
      .then((res) => {
        window.location.reload();
      })
      .finally(() => {
        setLoading(false)
        setIsOpenEditModal(false);
      });

  }

  const getPlanData = (planId) => {
    const plan = plans?.find((p) => p.id === planId);
    const price = plan?.prices?.[0];
    const currency = currencies?.find((c) => c.code === price?.currency);

    const data = {
      plan_id: plan?.id,
      plan_type: price?.billing_period || "monthly",
      price: price?.price || 0,
      currency: currency?.id,
      trial_period_days: plan?.settings?.trial_period_days || 0,
      unlimited_items: plan?.settings?.unlimited_items || 0,
      max_inventory_items: plan?.settings?.max_inventory_items || 0,
      max_inventory_items_ml: plan?.settings?.max_inventory_items_ml || 0,
      max_inventory_items_kg_pc: plan?.settings?.max_inventory_items_kg_pc || 0,
      auto_subscription_start: false,
      auto_renew: false,
    };
    return data;    
  }

  const handleChangePlanData = (field, value) => {
    if(field === 'plan_id') {
      const planData = getPlanData(value);
      setPlanData({...planData});
      return;
    }
    setPlanData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const rows = branchList?.map((branch) => (
    <tr key={branch.id} className={`px-2 py-2 m-2 my-3 font-weight-bold position-relative`}>
      <td className="text-left px-4">
        <div className="font-size-sm user_list_brake">{branch?.name}</div>
      </td>
      <td className="text-left px-4">
        <div className="font-size-sm">{branch?.phone} </div>
      </td>
      <td className="text-left px-4">
        <div className="font-size-sm">
          {branch?.analyticsV2?.prevMonthInventoriesCount} /{" "}
          {branch?.analyticsV2?.prevMonthTotalCount} ({translation.ml}:{branch?.analyticsV2?.prevMonthInventoriesCountMl}, {translation.kg}/{translation.pc}:{branch?.analyticsV2?.prevMonthInventoriesCountKgPc})
        </div>
      </td>
      <td className="text-left px-4">
        <div className="font-size-sm">
          {branch?.analyticsV2?.currentMonthInventoriesCount} /{" "}
          {branch?.analyticsV2?.currentMonthTotalCount} ({translation.ml}:{branch?.analyticsV2?.currentMonthInventoriesCountMl}, {translation.kg}/{translation.pc}:{branch?.analyticsV2?.currentMonthInventoriesCountKgPc})
        </div>
      </td>
      <td className="text-left px-4">
        <div className="font-size-sm">{branch?.address} </div>
      </td>
      <td className="text-left px-4">
        <div className="font-size-sm text-capitalize">
          {!!branch?.status ? translation.active : translation.inactive}{" "}
        </div>
      </td>
      <td className="text-left px-4">
        <div className="font-size-sm align-box-row">
          <Button
            variant="contained"
            type="button"
            onClick={() => {
              setOpenId(branch?.id);
              setIsOpen((prev) => !prev);
            }}
            className="mr-2 button-1"
          >
            {translation.action}
          </Button>
          {isOpen && branch.id === openId && (
            <UsersActionCard>
              <BranchDetailsButtons
                branch={branch}
                actionHandler={actionHandler}
                editPlanHandler={editPlanHandler}
              />
            </UsersActionCard>
          )}
        </div>
      </td>
    </tr>
  ));

  return (
    <WrapperSeamless>
      <Table
        fields={
          <>
            <th className="text-left px-4">
              <span className="mr-3">{translation.name}</span>
            </th>
            <th className="text-left px-4">
              <span className="mr-3">{translation.phone}</span>
            </th>
            <th className="text-left px-4">
              <span className="mr-3">{translation.branch_prev_month}</span>
            </th>
            <th className="text-left px-4">
              <span className="mr-3">{translation.branch_current_month}</span>
            </th>
            <th className="text-left px-4">
              <span className="mr-3">{translation.address}</span>
            </th>
            <th className="text-left px-4">
              <span className="mr-3">{translation.status}</span>
            </th>
            <th className="text-left px-4">
              <span className="mr-3">{translation.action}</span>
            </th>
          </>
        }
        noDrag
        title={translation.branches}
        items={branchList}
        rows={rows}
        actions={false}
        userPage
        datePicker={true}
        onDateChange={(newDate) => handleDateChange(newDate)}
      />
      <AcceptUserModal
        isUserModal={false}
        isShowPlans={true}
        isOpen={isOpenEditModal}
        close={closeEditModal}
        accept={handleSaveAction}
        text={translation.edit_branch_plan}
        loading={loading}
        plans={plans}
        currencies={currencies}
        handleChangePlanData={handleChangePlanData}
        planData={planData}
      />
    </WrapperSeamless>
  );
};
